import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_AppIcon = _resolveComponent("AppIcon")

  return (_openBlock(), _createElementBlock("a", {
    class: _normalizeClass(['side-menu-link', { active: _ctx.isActive }]),
    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.navigate && _ctx.navigate(...args)))
  }, [
    (_ctx.item.icon)
      ? (_openBlock(), _createBlock(_component_AppIcon, {
          key: 0,
          icon: _ctx.item.icon,
          mdi: _ctx.item.mdiIcon,
          left: ""
        }, null, 8, ["icon", "mdi"]))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(_ctx.item.title), 1)
  ], 2))
}